import React from 'react';

interface ServiceBillingProps {
  professionalId: string;
  onNavigate: (component: string) => void;
}

const ServiceBilling: React.FC<ServiceBillingProps> = ({ professionalId, onNavigate }) => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Faturamento e Serviços</h1>
      <p className="text-gray-600">Componente em desenvolvimento</p>
      <button
        onClick={() => onNavigate('dashboard')}
        className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
      >
        ← Dashboard
      </button>
    </div>
  );
};

export default ServiceBilling; 